// utils.js or another file of your choice

export async function getEncryptedField(endpoint, email) {
  const token = localStorage.getItem('authToken');

  if (!token) {
    return { error: 'Token not found in local storage.' };
  }

  try {
    const response = await fetch(endpoint + '?field=' + encodeURIComponent(email), {
      headers: { 'Authorization': `Bearer ${token}` }
    });

    if (!response.ok) {
      const errorData = await response.json();
      return { error: JSON.stringify(errorData) };
    }

    const { encryptedField } = await response.json();
    return { encryptedField, token };
  } catch (error) {
    return { error: error.message };
  }
}

// module.exports = {s
//   getEncryptedField
// };


// async function getEncryptedField(endpoint, email) {
//   const token = localStorage.getItem('authToken');

//   if (!token) {
//     return { error: 'Token not found in local storage.' };
//   }

//   try {
//     const response = await fetch(endpoint + '?field=' + encodeURIComponent(email), {
//       headers: { 'Authorization': `Bearer ${token}` }
//     });

//     if (!response.ok) {
//       const errorData = await response.json();
//       return { error: JSON.stringify(errorData) };
//     }

//     const { encryptedField } = await response.json();
//     return { encryptedField, token };
//   } catch (error) {
//     return { error: error.message };
//   }
// }

// module.exports = {
//   getEncryptedField
// };
